import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AudioServiceService } from './audio-service.service';
import { GamePlayService } from './game-play/gamePlayService.service';
import { routeService } from './route-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  gameKind: string;
  constructor(private router: Router, private routeService: routeService, public gamePlayService: GamePlayService , private audioService: AudioServiceService) { }

  ngOnInit() {
    this.routeService.Init();
    this.audioService.loadSounds();
    this.router.navigate(['choose']);
  }

}
